import { Reveal } from "./Reveal";
import { RESIDENCES } from "../../lib/content";
import { scrollToSection } from "../../lib/scroll";
import { ArrowUpRight } from "lucide-react";

export default function Residences() {
  const go = () =>
    scrollToSection("#enquire");

  return (
    <section
      id="residences"
      data-testid="residences"
      className="relative bg-[#070707] py-28 md:py-40 border-y border-[#d4af37]/10 scroll-mt-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <span className="text-xs tracking-luxe uppercase text-[#d4af37]">
              The Residences
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif-lux text-4xl md:text-6xl mt-6 leading-[1.05] text-[#f5f5f0]">
              Two ways to{" "}
              <span className="italic gold-gradient-text">come home.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {RESIDENCES.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1}>
              <article
                data-testid={`residence-${i}`}
                className="group relative h-full gold-border bg-[#0b0b0b] overflow-hidden flex flex-col transition-colors duration-500 hover:border-[#d4af37]/60"
              >
                <div className="relative h-56 md:h-72 overflow-hidden">
                  <img
                    src={r.image}
                    alt={`${r.type} interior overlooking the Kasauli hills`}
                    className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0b] via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 glass border border-[#d4af37]/25 px-3 py-1 text-[10px] tracking-[0.2em] uppercase text-[#d4af37]">
                    0{i + 1}
                  </span>
                </div>
                <div className="p-8 md:p-10 flex flex-col flex-grow">
                  <h3 className="font-serif-lux text-3xl text-[#f5f5f0]">
                    {r.name}
                  </h3>
                  <p className="mt-2 text-sm tracking-[0.14em] uppercase text-[#d4af37]">
                    {r.type}
                  </p>
                  <div className="my-6 hairline" />
                  <p className="text-[#9a968c] leading-relaxed flex-grow">
                    {r.note}
                  </p>
                  <div className="mt-8 flex items-end justify-between">
                    <div>
                      <p className="text-[10px] tracking-[0.2em] uppercase text-[#6b6b64]">
                        Carpet Area
                      </p>
                      <p className="text-[#f5f5f0] mt-1">{r.size}</p>
                    </div>
                    <button
                      data-testid={`residence-enquire-${i}`}
                      onClick={go}
                      aria-label={`Enquire about ${r.name}`}
                    className="w-11 h-11 rounded-full border border-[#d4af37]/40 flex items-center justify-center text-[#d4af37] transition-all duration-500 group-hover:bg-[#d4af37] group-hover:text-black"
                  >
                    <ArrowUpRight size={18} />
                  </button>
                </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 text-xs text-[#6b6b64] tracking-wide">
            * Indicative configurations and areas. Detailed floor plans shared
            with the private brochure.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
